import { logger } from '../logger';

export function injectAuthorGlobalCss({
  isAuthorMode,
  remoteUrl,
  globalStylesVersion,
  rtlEnable,
  assetPrefix,
}: {
  isAuthorMode?: boolean;
  remoteUrl?: string;
  globalStylesVersion: string;
  rtlEnable?: boolean;
  assetPrefix?: string;
}) {
  if (!isAuthorMode) return;

  const { log } = logger({})('[injectAuthorGlobalCss]');
  let resolvedOrigin = '';
  try {
    resolvedOrigin = remoteUrl
      ? new URL(remoteUrl).origin
      : document.body.dataset['remoteUrl']
      ? new URL(document.body.dataset['remoteUrl']).origin
      : '';
  } catch {
    log.debug('[injectAuthorGlobalCss] Non-remote author mode fallback used.');
  }

  const assetUrl = `${resolvedOrigin || 'https://www.marriott.com'}${assetPrefix || ''}`;

  // TODO: fix typo to 'marriott' when CSS file is renamed
  const href = `${assetUrl}/global-styles/${globalStylesVersion}/marriot.global${rtlEnable ? '.rtl' : ''}.css`;

  // avoid duplicates
  if (document.querySelector(`link[href="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}
